import React from 'react';
import { SiteLink } from '../../components';

/**
 * Breadcrumb Component
 * 
 * Renders a visual breadcrumb navigation list.
 * Works seamlessly with BreadcrumbSchema component for SEO.
 * 
 * @param {Object} props
 * @param {Object} props.breadcrumb - Breadcrumb data object
 * @param {Array} props.breadcrumb.items - Array of breadcrumb items
 * @param {string} props.breadcrumb.items[].title - Display text for the breadcrumb item
 * @param {string} props.breadcrumb.items[].link - URL path for the breadcrumb item (optional)
 */
export function Breadcrumb({ breadcrumb }) {
  // Handle null/undefined breadcrumb gracefully
  if (!breadcrumb || !breadcrumb.items || !Array.isArray(breadcrumb.items) || breadcrumb.items.length === 0) {
    return null;
  }

  return (
    <ul className="breadcrumb">
      {breadcrumb.items.map((item, index) => Item(item, index))}
    </ul>
  );
}

function Item(item, index) {
  // Handle null/undefined item gracefully
  if (!item || !item.title) {
    return null;
  }

  if (item.link) {
    return (
      <li key={index}><SiteLink to={item.link}>{item.title}</SiteLink></li>
    )
  } else {
    return (
      <li key={index}>{item.title}</li>
    )
  }
}